<nav
  class="bn-main-menu"
  data-e2e="MainMenu">
  <ul>
    @for (menuItem of menuItems; track menuItem.route ?? $index) {
      <li
        *roleIds="menuItem.roleIds"
        class="bn-main-menu__item {{ menuItem.class }}"
        [ngClass]="{ 'bn-main-menu__link--open': menuItem.isOpen }">
        <ng-container *ngTemplateOutlet="itemUrl; context: { menuItem: menuItem }" />
        @if (menuItem.children?.length) {
          <ul class="bn-main-menu__sub-menu">
            <ng-container *roleIds="menuItem.roleIds">
              <ng-container *featureFlag="menuItem.featureFlag">
                @for (childMenuItem of menuItem.children; track childMenuItem.route ?? $index) {
                  <li class="bn-main-menu__item">
                    <ng-container *ngTemplateOutlet="itemUrl; context: { menuItem: childMenuItem, isChildItem: true }" />
                  </li>
                }
              </ng-container>
            </ng-container>
          </ul>
        }
      </li>
    }
  </ul>
</nav>

<ng-template
  #itemUrl
  let-isChildItem="isChildItem"
  let-menuItem="menuItem">
  @if (menuItem.url) {
    <a
      class="bn-main-menu__link"
      [href]="menuItem.url"
      [target]="menuItem.target">
      @if (menuItem.icon && isChildItem) {
        <div class="bn-main-menu__icon-container">
          <fa-icon
            class="bn-main-menu__icon"
            [icon]="menuItem.icon" />
        </div>
      }
      {{ menuItem.name }}
      @if (menuItem.icon && !isChildItem) {
        <fa-icon
          class="bn-main-menu__icon"
          [icon]="menuItem.icon" />
      }
    </a>
  } @else {
    <a
      *featureFlag="menuItem.featureFlag"
      ariaCurrentWhenActive="page"
      class="bn-main-menu__link"
      data-e2e="MainMenuActive"
      routerLinkActive="bn-main-menu__link--active"
      [ngClass]="{ 'bn-main-menu__link--faded': menuItem.isFaded }"
      [routerLink]="menuItem.route || null"
      [routerLinkActiveOptions]="{ exact: menuItem.route === '/' }"
      (click)="onMenuItemClick(menuItem, isChildItem)">
      @if (menuItem.icon && isChildItem) {
        <div class="bn-main-menu__icon-container">
          <fa-icon
            class="bn-main-menu__icon"
            [icon]="menuItem.icon" />
        </div>
      }
      {{ menuItem.name }}
      @if (menuItem.icon && !isChildItem) {
        <fa-icon
          class="bn-main-menu__icon"
          [icon]="menuItem.icon" />
      }
      @if (!!menuItem.badge) {
        <bn-web-ui-badge
          contentClass="ms-2"
          [color]="menuItem.badge.context"
          [size]="menuItem.badge.size"
          [type]="menuItem.badge.type"
          >{{ menuItem.badge.text }}</bn-web-ui-badge
        >
      }
      @if (menuItem.children?.length) {
        <fa-icon
          class="bn-main-menu__icon bn-main-menu__arrow"
          icon="chevron-down" />
      }
    </a>
  }
</ng-template>
